import request from 'tools/request'
import { CountryCollectionResponse } from 'types/country'

export const getCountries = async () => {
  const data = await request.get<CountryCollectionResponse>(`/countries`).then((res) => res.data.countries)
  return data
}
